export default "__VITE_ASSET__DzyDSSw0__"